module.exports = __webpack_public_path__ + "img/get-free-insurance-quote-page-top.74e302c9.svg";